import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableScasService {
  private params: BehaviorSubject<any> = new BehaviorSubject<any>('');
  constructor() {}
  setParams(data) {
    console.log('table service data-->', data);
    this.params.next(data);
  }
  getParams() {
    return this.params.asObservable();
  }
}
